const platforms = [
  {
    id: "emf2024",
    description: "Electromagnetic Field 2024 Badge Hexpansion",
    link: "https://infosec.exchange/@fridgehead/116215929421642291",
  },
  {
    id: "gba",
    description: "Nintendo Game Boy Advance",
    link: "https://github.com/dectalk/DECtalkMini/tree/dectalk-develop/platforms/gba",
  },
  {
    id: "hytale",
    description: "Hytale mod",
    link: "https://github.com/Azim/HytaleMoonbaseTTS",
  },
  {
    id: "minecraft",
    description: "Minecraft Forge mod",
    link: "https://github.com/dectalk/DECtalkMini/tree/dectalk-develop/platforms/minecraft",
  },
  {
    id: "nodejs",
    description: "native node addon",
    link: "https://github.com/dectalk/DECtalkMini/tree/dectalk-develop/platforms/node",
  },
  {
    id: "pico",
    description: "Raspberry Pi RP2040",
    link: "https://github.com/dectalk/DECtalkMini/tree/dectalk-develop/platforms/pico",
  },
  {
    id: "uefi",
    description: "UEFI",
    link: "https://github.com/dectalk/DECtalkMini/tree/dectalk-develop/platforms/uefi",
  },
  {
    id: "wasm",
    description: "WebAssembly",
    link: "https://www.npmjs.com/package/@dectalk/dectalk",
  },
  {
    id: "web",
    description: "Emscripten",
    link: "https://bytesizedfox.dev/",
  },
];

export { platforms };
